/** @format */

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-component-brand-link',
	imports: [HmfTextLinkComponent],
	templateUrl: './brand-link.component.html',
	styleUrl: './brand-link.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandLinkComponent {
	readonly brandLink = input.required<{ name: string; url: string }>();
	readonly isMobile = input.required<boolean>();

	readonly size = computed(() => (this.isMobile() ? 'medium' : 'large'));
	readonly dataEm = computed(() => {
		const brandName = this.brandLink().name;
		const brandNameSanitized = brandName.replace(/ /g, '_');
		return `pdpProductTitle_${brandNameSanitized}`;
	});
}
